const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer__text">
        Made with ❤️️ by <a
          className="author"
          href="https://twitter.com/GeekyChakri"
          target="_blank"
          rel="noopener noreferrer"
        >
          Chakri
        </a>
      </p>
    </footer>
  );
};

export default Footer;
